import { ActionKeys } from '~/actions/constants';
import { type ActionTypes } from '~/actions/index';

// TODO: update this file with Filters = { [filterGroupName: string]: { arrayFilters: Array<string>, values: { [filterName: string]: any } } }
export type Filters = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [filterGroupName: string]: { [filterName: string]: any };
};

export type FiltersState = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly filterGroups: any[];
  readonly showNewTab: boolean;
  readonly tempFilterGroup: Maybe<Filters>;
};

export const initialState: FiltersState = {
  filterGroups: [],
  showNewTab: false,
  tempFilterGroup: null,
};

const reducer = (state = initialState, action: ActionTypes): FiltersState => {
  switch (action.type) {
    case ActionKeys.FILTER_SAVE_FILTER_GROUP_SUCCESS:
      return {
        ...state,
        filterGroups: [...state.filterGroups, action.payload.data],
        showNewTab: false,
      };
    case ActionKeys.FILTER_SAVE_FILTER_GROUP_ERROR:
      return {
        ...state,
      };
    case ActionKeys.FILTER_GET_FILTER_GROUPS:
      return {
        ...state,
      };
    case ActionKeys.FILTER_GET_FILTER_GROUPS_SUCCESS:
      return {
        ...state,
        filterGroups: action.payload.data,
      };
    case ActionKeys.FILTER_GET_FILTER_GROUPS_ERROR:
      return {
        ...state,
      };
    case ActionKeys.FILTER_DELETE_FILTER_GROUP_SUCCESS:
      return {
        ...state,
      };
    case ActionKeys.FILTER_DELETE_FILTER_GROUP_ERROR:
      return {
        ...state,
      };
    case ActionKeys.FILTER_SHOW_NEW_TAB:
      return {
        ...state,
        showNewTab: true,
      };
    case ActionKeys.FILTER_HIDE_NEW_TAB:
      return {
        ...state,
        showNewTab: false,
      };
    case ActionKeys.FILTER_CHANGE_TAB_SUCCESS:
      return {
        ...state,
      };
    case ActionKeys.FILTER_SAVE_TEMP_GROUP:
      return {
        ...state,
        tempFilterGroup: action.payload.filters,
      };
    default:
      return state;
  }
};

export default reducer;
